import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Select, MenuItem, FormControl, InputLabel, Divider, Grid, FormControlLabel, Checkbox, Radio } from '@material-ui/core'
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { GameMultiSelect, PfSubPfMultiSelect } from '@select'
import moment from 'moment'

const initialState = {
    input: {
        id: 0,
        type: 'system',
        start_at: utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day'),
        end_at: utils.datetimeEndOfWithoutOffset(utils.currentDatetime(), 'day'),
        cycle: 1,
        is_active: false,
        title: '',
        language: {
            'CHS': false,
            'VIE': false,
            'ENU': false,
            'THA': false,
            'IDR': false,
            'ESP': false,
            'PTE': false,
        },
        content: {
            'CHS': '',
            'VIE': '',
            'ENU': '',
            'THA': '',
            'IDR': '',
            'ESP': '',
            'PTE': '',
        },
        gameList: [],
        pfSubPfIDList: [],
        specifyPf: 'notSpecify',
        specifyGame: 'notSpecify',
    },
    type: 'edit',
    valid: false,
    dialogOpen: false,
}

class EditMarqueeDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'EditMarqueeDialog')
        }
        this.state = JSON.parse(JSON.stringify(initialState))
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(inputs) {
        if (inputs) {
            this.editInitData(inputs)
        } else {
            this.setState({
                input: JSON.parse(JSON.stringify(initialState.input)),
                valid: false,
                type: 'add'
            })
        }
        
    }

    editInitData(data) {
        const input = JSON.parse(JSON.stringify(initialState.input))
        input.id = data.id
        input.type = data.type
        input.start_at = utils.unixToDateTime(data.start_at)
        input.end_at = utils.unixToDateTime(data.end_at)
        input.cycle = data.cycle
        input.is_active = data.is_active
        input.title = data.title
        input.gameList = data.game_list || []
        input.specifyGame = data.game_list ? 'specify' : 'notSpecify'
        input.pfSubPfIDList = data.pf_sub_pf_id_list || []
        input.specifyPf = data.pf_sub_pf_id_list ? 'specify' : 'notSpecify'
        Object.entries(data.content).forEach(([lang, content]) => {
            input.language[lang] = true
            input.content[lang] = content
        })
        this.setState({
            input,
            valid: false,
						type: 'edit'
        })
        
    }

    OpenDialog(inputs) {
        this.setState({ dialogOpen: true }, ()=> {
            this.reset(inputs)
        })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    handleTitleValid() {
        let valid = false
        valid = Boolean(this.state.input.title.trim())
        return valid
    }

    handleContentValid(type) {
        if (this.state.input.language[type] && (Boolean(this.state.input.content[type].trim()) === false || String(this.state.input.content[type].trim()).length > 200)) {
            return false
        } else {
            return true
        }
    }
    handleTimeValid() {
        return moment(this.state.input.end_at).isAfter(this.state.input.start_at, 'minutes')
    }

    handleSubmit() {
        this.setState({
            valid: true
        })
        const valid = []
        /** 標題驗證 */
        valid.push(this.handleTitleValid())
        /** 平台驗證 */
        if (this.state.input.pfSubPfIDList.length === 0 && this.state.input.specifyPf === 'specify') {
            utils.addToast(utils.t('choosePlatform', 'AddMarqueeDialog'), 'error')
            valid.push(false)
        }
        /** 遊戲驗證 */
        if (this.state.input.gameList.length === 0 && this.state.input.specifyGame === 'specify') {
            utils.addToast(utils.t('chooseGames', 'AddMarqueeDialog'), 'error')
            valid.push(false)
        }
        /** 內容驗證 */
        if (Object.values(this.state.input.language).find(item => item) !== true) {
            utils.addToast(utils.t('enterContent', 'AddMarqueeDialog'), 'error')
            valid.push(false)
        }
        Object.entries(this.state.input.language).forEach(([key, checked])=>{
            if (checked && !this.handleContentValid(key)) {
                valid.push(false)
            }
        })
        /** 時間驗證 */
        if (!this.handleTimeValid()) {
            valid.push(false)
        }
        /** 驗證失敗不繼續送出 */
        if (valid.find(value => !value) === false) { return }

        const params = {
            title: this.state.input.title,
            type: this.state.input.type,
            pf_sub_pf_id_list: this.state.input.specifyPf === 'specify' ? this.state.input.pfSubPfIDList : [],
            game_list: this.state.input.specifyGame === 'specify' ? this.state.input.gameList : [],
            start_at: utils.datetimeToUnix(this.state.input.start_at),
            end_at: utils.datetimeToUnix(this.state.input.end_at),
            cycle: this.state.input.cycle,
            is_active: this.state.input.is_active,
            content: {}
        }
        if (this.state.type === 'edit') {
            params.id = this.state.input.id
        }
        Object.entries(this.state.input.language).forEach(([lang, bool]) => {
            if (bool === true) {
                params.content[lang] = this.state.input.content[lang]
            }
        })

        const apiMethods = this.state.type === 'add' ? 'post' : 'put'
        utils.apiRequest(
            apiMethods,
            API.MARQUEE,
            params,
            (_data) => {
                this.confirm()
            }
        )
    }
    /** 子層遊戲列表ckecked */
    handlecheckGame(value) {
        const input = JSON.parse(JSON.stringify(this.state.input))
        input.gameList = value
        this.setState({
            input
        })
    }
    /** 子層站台列表ckecked */
    handlecheckSubPlatform(value) {
        const input = JSON.parse(JSON.stringify(this.state.input))
        input.pfSubPfIDList = value
        this.setState({
            input
        })
    }

    render() {
        return (
            <Dialog maxWidth="xs" fullWidth open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.state.type === 'add' ? this.t('AddTitle') : this.t('Title')}</DialogTitle>
                <DialogContent>
                <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                autoFocus
                                label={utils.t('title', 'AddMarqueeDialog')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.title}
                                onChange={(event) =>
                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            title: event.target.value,
                                        },
                                    })
                                }
                                margin="dense"
                                fullWidth
                                required={true}
                                error={this.state.valid && !this.handleTitleValid()}
                                helperText={this.state.valid && !this.handleTitleValid() ? utils.t('enterTitle', 'AddMarqueeDialog') : ''}
                            />
                            <FormControl margin="dense" fullWidth>
                                <InputLabel htmlFor="age-simple">{this.t('type')}</InputLabel>
                                <Select
                                    value={this.state.input.type}
                                    onChange={(event) =>
                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                type: event.target.value,
                                            },
                                        })
                                    }>
                                    <MenuItem value="system">{this.t('system')}</MenuItem>
                                    <MenuItem value="event">{this.t('event')}</MenuItem>
                                </Select>
                            </FormControl>
                            <Grid item xs={12}>
                                <div>
                                    <FormControlLabel
                                        className={this.props.classes.labelReset}
                                        value="notSpecify"
                                        checked={this.state.input.specifyPf === 'notSpecify'}
                                        onChange={(event)=>{
                                            const input = this.state.input
                                            input.specifyPf = event.target.value
                                            this.setState({
                                                input
                                            })
                                        }}
                                        control={<Radio color="primary" />}
                                        label={this.t('notSpecifyPf')}
                                    />
                                    <FormControlLabel
                                        className={this.props.classes.labelReset}
                                        value="specify"
                                        checked={this.state.input.specifyPf === 'specify'}
                                        onChange={(event)=>{
                                            const input = this.state.input
                                            input.specifyPf = event.target.value
                                            this.setState({
                                                input
                                            })
                                        }}
                                        control={<Radio color="primary" />}
                                        label={this.t('specifyPf')}
                                    />
                                </div>
                                {this.state.input.specifyPf === 'specify' && <PfSubPfMultiSelect
                                    onRef={(ref) => (this.subPfSelect = ref)}
                                    classes={{
                                        formControl: this.props.classes.formControl,
                                        treeSelect: this.props.classes.treeSelect
                                    }}
                                    options={{
                                        showAllSubPlatform: true,
                                        hideAllPlatform: false,
                                        hidePf: true,
                                        hideCurrencyTitle: true,
                                        hidePfSubPfTitle: true
                                    }}
                                    pfSubPfIDList={this.state.input.pfSubPfIDList}
                                    checkValue={(value)=>this.handlecheckSubPlatform(value)}
                                    hideCurrencyTitle={true}
                                    hidePfSubPfTitle={true}
                                />}
                            </Grid>
                            <Grid item xs={12}>
                                <div>
                                    <FormControlLabel
                                        className={this.props.classes.labelReset}
                                        value="notSpecify"
                                        checked={this.state.input.specifyGame === 'notSpecify'}
                                        onChange={(event)=>{
                                            const input = this.state.input
                                            input.specifyGame = event.target.value
                                            this.setState({
                                                input
                                            })
                                        }}
                                        control={<Radio color="primary" />}
                                        label={this.t('notSpecifyGame')}
                                    />
                                    <FormControlLabel
                                        className={this.props.classes.labelReset}
                                        value="specify"
                                        checked={this.state.input.specifyGame === 'specify'}
                                        onChange={(event)=>{
                                            const input = this.state.input
                                            input.specifyGame = event.target.value
                                            this.setState({
                                                input
                                            })
                                        }}
                                        control={<Radio color="primary" />}
                                        label={this.t('specifyGame')}
                                    />
                                </div>
                                {this.state.input.specifyGame === 'specify' && <GameMultiSelect
                                    onRef={(ref) => (this.gameSelect = ref)}
                                    classes={{
                                        formControl: this.props.classes.formControl,
                                        treeSelect: this.props.classes.treeSelect
                                    }}
                                    hideTitle={true}
                                    gameLobby={true}
                                    gameList={this.state.input.gameList}
                                    checkValue={(value)=>this.handlecheckGame(value)}
                                />}
                            </Grid>
                            <div className={this.props.classes.dateTimeGroup}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DateTimePicker
                                        invalidDateMessage={this.t('DatePicker.invalidDateMessage')}
                                        maxDateMessage={this.t('DatePicker.maxDateMessage')}
                                        minDateMessage={this.t('DatePicker.minDateMessage')}
                                        value={this.state.input.start_at}
                                        // disablePast
                                        onChange={(value) =>
                                            this.setState({
                                                input: {
                                                    ...this.state.input,
                                                    start_at: value,
                                                },
                                            })
                                        }
                                        label={this.t('startAt')}
                                        format="yyyy/MM/dd HH:mm"
                                        margin="dense"
                                        variant="inline"
                                        className={this.props.classes.dateTime}
                                    />
                                </MuiPickersUtilsProvider>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DateTimePicker
                                        invalidDateMessage={this.t('DatePicker.invalidDateMessage')}
                                        maxDateMessage={this.t('DatePicker.maxDateMessage')}
                                        minDateMessage={this.t('DatePicker.minDateMessage')}
                                        minDate={this.state.input.start_at}
                                        value={this.state.input.end_at}
                                        // disablePast
                                        onChange={(value) =>
                                            this.setState({
                                                input: {
                                                    ...this.state.input,
                                                    end_at: value,
                                                },
                                            })
                                        }
                                        label={this.t('endAt')}
                                        format="yyyy/MM/dd HH:mm"
                                        margin="dense"
                                        variant="inline"
                                        error={this.state.valid && !this.handleTimeValid()}
                                        helperText={this.state.valid && !this.handleTimeValid() ? this.t('timeValid'): ''}
                                        className={this.props.classes.dateTime}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            <FormControl margin="dense" fullWidth>
                                <InputLabel>{this.t('cycle')}</InputLabel>
                                <Select
                                    value={this.state.input.cycle}
                                    onChange={(event) =>
                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                cycle: event.target.value,
                                            },
                                        })
                                    }>
                                    <MenuItem value={1}>1 {this.t('cycleOption')}</MenuItem>
                                    <MenuItem value={3}>3 {this.t('cycleOption')}</MenuItem>
                                    <MenuItem value={5}>5 {this.t('cycleOption')}</MenuItem>
                                    <MenuItem value={10}>10 {this.t('cycleOption')}</MenuItem>
                                    <MenuItem value={30}>30 {this.t('cycleOption')}</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl margin="dense" fullWidth>
                                <InputLabel>{this.t('isActive')}</InputLabel>
                                <Select
                                    value={this.state.input.is_active}
                                    onChange={(event) =>
                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                is_active: event.target.value,
                                            },
                                        })
                                    }>
                                    <MenuItem value={true}>{this.t('enable')}</MenuItem>
                                    <MenuItem value={false}>{this.t('disable')}</MenuItem>
                                </Select>
                            </FormControl>
                            <InputLabel
                                className={this.props.classes.contentTitle}
                                shrink={true}
                                required={true}
                            >
                                {this.t('content')}
                            </InputLabel>
                            {Object.entries(this.state.input.language).map(([item, ckecked]) => {
                                return (<Grid item xs={12}  key={item}>
                                    <FormControlLabel
                                        className={this.props.classes.labelReset}
                                        control={
                                            <Checkbox
                                                checked={this.state.input.language[item]}
                                                onChange={(event) => {
                                                    const input = this.state.input
                                                    input.language[item] = event.target.checked
                                                    this.setState({
                                                        input,
                                                    })
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label={utils.t(`Language.${item}`)}
                                    />
                                    {ckecked && <TextField
                                        label=""
                                        fullWidth
                                        value={this.state.input.content[item]}
                                        onChange={(event) =>{
                                            const input = this.state.input
                                            input.content[item] = event.target.value
                                            this.setState({
                                                input,
                                            })
                                        }}
                                        error={this.state.valid && ckecked && !this.handleContentValid(item)}
                                        helperText={this.state.valid && ckecked && !this.handleContentValid(item) ? utils.t('enterContentLimit', 'AddMarqueeDialog') : ''}
                                    />}
                                </Grid>)
                            })}
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => this.handleSubmit()}
                        color="primary">
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        formControl: {
            margin: 0,
            marginTop: 8,
            marginBottom: 8,
            width: '100%'
        },
        treeSelect: {
            width: 250,
        },
        labelReset: {
            marginBottom: 0
        },
        contentTitle: {
            marginTop: 10,
            marginBottom: 0
        },
        dateTimeGroup: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        dateTime: {
            width: '48%'
        }
    }
}

EditMarqueeDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    auth: PropTypes.object,
}

export default hoc(styles)(EditMarqueeDialog)
